<template>
  <div class="inputfile-container" :class="{focus:isFocus, 'input-name':inputName}">
    <div class="selected-file">
      <div class="thumnail">
        <img
          v-show="thumnail"
          class="preview-file"
          :src="thumnail"
        />
      </div>
      <!-- <div>
        <span v-if="isOpenBtn" class="fa-solid fa-arrow-up-right-from-square btn-new-tab" @click="fileOpenNewTab"></span>
        <span class="fa-solid fa-download btn-download" @click="fileDownload"></span>
      </div> -->
    </div>
    <p class="filename" v-if="inputName">
      <input-text type="text" max-length="128" v-model="fileName" :placeholder="nameLabel" readonly="true"></input-text>
    </p>
    <div class="buttons">
      <button v-if="isOpenBtn" class="btn info" @click="fileOpenNewTab">表示</button>
      <button class="btn primary" @click="fileDownload">ダウンロード</button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import InputText from './InputText.vue'

export default defineComponent({
  props: ['modelValue', 'name', 'inputName', 'nameLabel', 'baseUrl'],
  setup(props, context) {
    if (typeof props.modelValue !== 'object') {
      context.emit('update:modelValue', {})
    }
    const uploadedFile = ref<any>(null)
    let fileName = computed({
      get: () => {
        return (props.modelValue.name) ? props.modelValue.name : null
      },
      set: (val) => {
        if (val === null) {
          delete props.modelValue.name
        } else {
          props.modelValue.name = val
        }
      }
    })
    const thumnail = computed({
      get: () => {
        if (props.modelValue) {
          if (isBase64(props.modelValue.file)) {
            // Base64形式だった場合
            const mime = getMimeByBase64(props.modelValue.file)
            if (mime) {
              if (isImage(mime)) {
                // 画像だった場合はそのまま表示
                return props.modelValue.file
              } else {
                return getIconPath(mime)
              }
            } else {
              return null
            }
          } else {
            if (props.modelValue.file) {
              if (isImage(props.modelValue.mime)) {
                return props.baseUrl + '/' + props.modelValue.file
              } else {
                return getIconPath(props.modelValue.mime)
              }
            } else {
              return null
            }
          }
        } else {
          return null
        }
      },
      set: (val) => {
        if (val === null) {
          delete props.modelValue.file
        } else {
          props.modelValue.file = val
        }
      }
    })
    const isFocus = ref(false)
    const onFocus = () => isFocus.value = true
    const onBlur = () => isFocus.value = false

    /**
     * Base64か判断します
     * @param str
     * @returns
     */
    const isBase64 = (str: string): boolean => {
      if (typeof str !== 'string') {
        return false
      }
      if (/^data:\w+\/[^;]+;base64,/.test(str)) {
        return true
      } else {
        const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
        return base64regex.test(str)
      }
    }

    const isImage = (mime: string): boolean => {
      return mime !== null && /^image\//.test(mime)
    }

    const getMimeByBase64 = (str: string): string|null => {
      if (typeof str !== 'string') {
        return null
      }
      const mimeRegex = /^data:(\w+\/[^;]+);base64,/
      const mime = str.match(mimeRegex)
      return (mime !== null) ? mime[1] : null
    }

    /**
     * アイコンのパスか判断します
     * @param str
     * @returns
     */
    const getIconPath = (mime: string): string => {
      if (mime === 'application/pdf') {
        return '/img/icon/upload-pdf.png'
      } else if (mime.indexOf('application/vnd.ms-excel') === 0 || mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        return '/img/icon/upload-excel.png'
      } else if (mime.indexOf('application/msword') === 0 || mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        return '/img/icon/upload-word.png'
      } else if (mime.indexOf('application/vnd.ms-powerpoint') === 0 || mime === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
        return '/img/icon/upload-powerpoint.png'
      } else {
        return '/img/icon/upload-file.png'
      }
    }

    const fileDownload = () => {
        context.emit('download:modelValue', props.modelValue)
    }

    const fileOpenNewTab = () => {
        context.emit('open:modelValue', props.modelValue)
    }

    const isOpenBtn = computed(() => {
      const mime = props.modelValue.file.split('.').pop()
      switch(mime){
        case 'pdf':
        case 'png':
        case 'jpg':
          return true
        default:
          return false
      }
    })

    return {
      uploadedFile,
      fileName,
      thumnail,
      isFocus,
      isOpenBtn,
      onFocus,
      onBlur,
      fileDownload,
      fileOpenNewTab
    }
  },
  components: {
    'input-text': InputText
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/form/input-file.scss';
@import '@scss/form/download-file.scss';
</style>
